module.exports = __webpack_public_path__ + "static/img/epr@1x.af738a6.png";


//////////////////
// WEBPACK FOOTER
// ./xcloud-client-components-web/assets/images/epr@1x.png
// module id = /a6x
// module chunks = 0